import nacl from "tweetnacl";
import naclUtil from "tweetnacl-util";

export const SESSION_EXPIRED_EVENT = "SESSION_EXPIRED";

export const clearClientAuthData = () => {
  // Clear storages
  localStorage.clear();
  localStorage.removeItem("IS_AUTHENTICATED");
  sessionStorage.clear();

  // Clear normal cookies (cannot clear httpOnly here)
  document.cookie.split(";").forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
};


export const encryptText = (text, encryptionkey) => {
  const SECRET_KEY = naclUtil.decodeUTF8(encryptionkey);
  const nonce = nacl.randomBytes(nacl.secretbox.nonceLength);
  const messageUint8 = naclUtil.decodeUTF8(text);
  const box = nacl.secretbox(messageUint8, nonce, SECRET_KEY);

  const fullMessage = new Uint8Array(nonce.length + box.length);
  fullMessage.set(nonce);
  fullMessage.set(box, nonce.length);

  const base64FullMessage = naclUtil.encodeBase64(fullMessage);
  return base64FullMessage;
};

export const parseJwt = (token) => {
  if (!token) return null;
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => {
          return `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`;
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};